import { Component, Directive, EventEmitter, inject, Input, OnInit, Output, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { InvoicesService } from '../services/invoices.service';
import { environment } from '../../environments/environment';
import { DatePipe, JsonPipe } from '@angular/common';
import { BillingPortalProps } from '../models/BillingPortalProps';
import { NgbInputDatepickerConfig, NgbCalendar, NgbDateStruct, NgbDate} from '@ng-bootstrap/ng-bootstrap';
import '@angular/localize/init';
import { NgbPopoverWindow } from '@ng-bootstrap/ng-bootstrap/popover/popover';
import { min } from 'moment';
import { BansStorageService } from '../services/bans-storage.service';

interface IUsageRecord {
  date: string;
  time: string;
  sourceTel: string;
  destinationTel: string;
  serviceType : string;
  siteLocation: string;
  duration: string;
  rate: string;
  totalAmount: number;
  currency:string;
}


export type SortColumn = keyof IUsageRecord | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export interface SortEvent {
  column: SortColumn;
  direction: SortDirection;
}

@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()'
  }
})
export class NgbdSortableHeader {
  model!: NgbDateStruct;
  @Input() sortable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}
@Component({
  selector: 'app-usage-record',
  templateUrl: './usage-record.component.html',
    styleUrls: ['./usage-record.component.css']
})
export class UsageRecordComponent {
  banflag: boolean = false;
  customerIDs: Array<string> = [];
  usageRecord: Array<IUsageRecord> = [];
  AllusageRecord: Array<IUsageRecord> = [];
  banCAs = new Map<string, Array<string>>();
  bans: Array<string> = [];
  cano: Array<string> = [];
  model: any = {}; 
  isLoading = false;
  currentPage = 1;
  itemsPerPage = environment.itemsPerPage;
  date = inject(NgbCalendar);
  fromDate:NgbDate = this.date.getToday();
  toDate:NgbDate = this.date.getToday();
  minDate: NgbDateStruct = { year: this.fromDate.year, month: this.fromDate.month, day: this.fromDate.day };
  maxDate: NgbDateStruct = { year: this.fromDate.year, month: this.fromDate.month, day: this.fromDate.day };

  fromMaxDate: NgbDateStruct = { year: this.date.getToday().year, month: this.date.getToday().month, day: this.date.getToday().day };
  fromMinDate: NgbDateStruct = { year: this.date.getToday().year - 2, month: this.date.getToday().month, day: this.date.getToday().day };

  toggleLoading = () => this.isLoading = !this.isLoading;

  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;

  BillingPortalProps: BillingPortalProps = new BillingPortalProps();
  ban: string = "";
  isUsageAPICall: boolean = false;
  isAllUsageRecordLoaded: boolean = true;
  unSupportedBanUsage: boolean = false;

  constructor(private invoicesService: InvoicesService,config: NgbInputDatepickerConfig, private calender: NgbCalendar, private bansService: BansStorageService) {
    // days that don't belong to current month are not visible
    config.outsideDays = 'hidden';
    // setting datepicker popup to close only on click outside
    config.autoClose = 'outside';
    // setting datepicker popup to open above the input
    config.placement = ['top-left', 'top-right'];
  }

  isDisabled = (date: NgbDate, current?: {year: number, month: number}) => {
    const selectedDate: Date  = new Date(date.year, date.month, date.day);
    const minDate: Date  = new Date(this.minDate.year, this.minDate.month, this.minDate.day);
    const maxDate: Date  = new Date(this.maxDate.year, this.maxDate.month, this.maxDate.day);

    return selectedDate < minDate || selectedDate > maxDate; 
  }

  async ngOnInit(): Promise<void> {
    this.getBans();
    this.onDateSelection()
  }

  getBans() {
    this.bansService.bans.subscribe((bans: any) => {
      if (bans) {
        this.banCAs = bans;
        let ban = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_Dropdown_Value"))) || "";
        let firstBAN: any = this.banCAs.entries().next().value;
        this.ban = ban ? ban : firstBAN[0];
        this.getUsageRecords(this.ban);
      }
      else{
        this.bansService.banFlag.subscribe(
        (isPresent: boolean) => {
          if(!isPresent){
            this.AllusageRecord = []
            this.usageRecord = [];
            this.unSupportedBanUsage = true;
          }
        });
      }
    })
  }

  selectedBan() {
    if (this.ban != "BAN") {
      this.getUsageRecords(this.ban);
    }
  }

  selectBan(selectedBan: string): void {
    this.ban = selectedBan;
    if (this.ban != "BAN") {
      this.getUsageRecords(this.ban);
    }
  }

  async getUsageRecords(bpno: any) {
  var fromMonth = this.fromDate.month.toString().length==1?"0"+this.fromDate.month.toString() : this.fromDate.month.toString();
  var fromDay =  this.fromDate.day.toString().length==1?"0"+this.fromDate.day.toString() : this.fromDate.day.toString();
  var fromDateString = this.fromDate.year.toString()+"-"+fromMonth+"-"+fromDay;
  var toMonth = this.toDate.month.toString().length==1?"0"+this.toDate.month.toString() : this.toDate.month.toString();
  var toDay =  this.toDate.day.toString().length==1?"0"+this.toDate.day.toString() : this.toDate.day.toString();
  var toDateString =this.toDate.year.toString()+"-"+toMonth+"-"+toDay;

  console.log(fromDateString +"======="+toDateString);

    this.usageRecord = []
    this.banflag = false;
    (await this.invoicesService
      .getUsageRecord(bpno, fromDateString, toDateString))
      .subscribe((res: any) => {
        res.forEach((element: any) => {
          var data = {
            date: element.date,
            time: element.time,
            sourceTel: element.sourceTel,
            destinationTel: element.destinationTel,
            serviceType : element.serviceType,
            siteLocation:element.siteLocation,
            duration: element.duration,
            rate: element.rate,
            totalAmount: element.totalAmount,
            currency:element.currency
          }
          this.usageRecord.push(data);
        });
        this.usageRecord = this.usageRecord.sort((a: any, b: any) => {
          return <any>new Date(b.date).getTime() - <any>new Date(a.date).getTime();
        } );
        this.AllusageRecord = this.usageRecord;
        this.usageRecord = this.AllusageRecord.slice(0, this.itemsPerPage);
        this.banflag = true;
        this.resetLoadMoreButton();
        console.log(this.usageRecord)
      });
  }

  resetLoadMoreButton() {
    if (this.usageRecord.length === this.AllusageRecord.length) {
          this.isAllUsageRecordLoaded = true;
    }else{
      this.isAllUsageRecordLoaded = false;
    }
    }
    
  loadMoreUsageRecord = () => {
    if (this.usageRecord.length < this.AllusageRecord.length) {
      this.appendData();
    } else if (this.usageRecord.length === this.AllusageRecord.length) {
      this.isAllUsageRecordLoaded = true;
    }
  }
  
  appendData() {
    this.usageRecord = [...this.AllusageRecord];
    this.resetLoadMoreButton();
  }
  

  onSort({ column, direction }: SortEvent) {

    console.log("onsort fun", this.usageRecord)
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction === '' || column === '') {
      this.usageRecord = this.AllusageRecord.slice(0, this.usageRecord.length);
      console.log("if", this.usageRecord)

    } else {
      console.log("direction record:", this.usageRecord)

      this.AllusageRecord = [...this.AllusageRecord].sort((a, b) => {
        if(column.toLocaleLowerCase().includes("date")){
          if(direction === 'asc')
            return new Date(b[column]).getTime() - new Date(a[column]).getTime();
          else
            return new Date(a[column]).getTime() - new Date(b[column]).getTime();
        }else{
          const res = compare(a[column], b[column]);
          return direction === 'asc' ? res : -res;
        }
      });
      this.usageRecord = this.AllusageRecord.slice(0, this.usageRecord.length);
    }
  }

  onDateSelection() {
    const todaysDate = new Date(this.date.getToday().year, this.date.getToday().month, this.date.getToday().day);
    const maxDate = new Date(this.fromDate.year, this.fromDate.month  + 3, this.fromDate.day);

    this.toDate = this.fromDate;
    this.minDate = this.fromDate;
    
    this.maxDate = maxDate > todaysDate 
                    ? { year: this.date.getToday().year, month: this.date.getToday().month, day: this.date.getToday().day }
                    : { year: this.fromDate.year, month: this.fromDate.month + 3, day: this.fromDate.day };
  }
}